import { createMap, forMember, mapFrom, Mapper } from '@automapper/core';
import { entitySymbols, withMetadata } from '@pf/shared-utility';

import { IMappingProfile } from '@pf/shared-common';
import {
    ItemDimension,
    ItemDimensionsViewModel,
    ItemMeasurement,
    Weight,
    WeightViewModel,
} from '@control-tower/platform-wms';

const weightSymbols = entitySymbols('Weight');

withMetadata<Weight>(weightSymbols.dto, {
    unitOfMeasure: String,
    pounds: Object,
    kilograms: Object,
    grams: Object,
    ounces: Object,
});
withMetadata<Weight>(weightSymbols.entity, {
    unitOfMeasure: String,
    pounds: Object,
    kilograms: Object,
    grams: Object,
    ounces: Object,
});
withMetadata<WeightViewModel>(weightSymbols.createBody, {
    unitOfMeasure: String,
    value: Number,
});

export const WeightMetadataMap: IMappingProfile = {
    symbols: weightSymbols,
    profile: (mapper: Mapper) => {
        createMap<Weight, Weight>(
            mapper,
            weightSymbols.entity,
            weightSymbols.dto
        );
        createMap<Weight, Weight>(
            mapper,
            weightSymbols.dto,
            weightSymbols.entity
        );
        createMap<Weight, WeightViewModel>(
            mapper,
            weightSymbols.dto,
            weightSymbols.createBody,
            forMember(
                d => d.value,
                mapFrom(
                    s =>
                        s.unitOfMeasure &&
                        s[s.unitOfMeasure.toLowerCase() as keyof Weight]
                )
            )
        );
    },
};

const dimensionsSymbols = entitySymbols('Dimensions');

withMetadata<ItemDimension>(dimensionsSymbols.dto, {
    unitOfMeasure: String,
    length: Object,
    width: Object,
    height: Object,
    volume: Object,
});
withMetadata<ItemDimension>(dimensionsSymbols.entity, {
    unitOfMeasure: String,
    length: Object,
    width: Object,
    height: Object,
    volume: Object,
});
withMetadata<ItemDimensionsViewModel>(dimensionsSymbols.createBody, {
    unitOfMeasure: String,
    length: Number,
    width: Number,
    height: Number,
    volume: Number,
});

export const DimensionsMetadataMap: IMappingProfile = {
    symbols: dimensionsSymbols,
    profile: (mapper: Mapper) => {
        createMap<ItemDimension, ItemDimension>(
            mapper,
            dimensionsSymbols.entity,
            dimensionsSymbols.dto
        );
        createMap<ItemDimension, ItemDimension>(
            mapper,
            dimensionsSymbols.dto,
            dimensionsSymbols.entity
        );
        createMap<ItemDimension, ItemDimensionsViewModel>(
            mapper,
            dimensionsSymbols.dto,
            dimensionsSymbols.createBody,
            forMember(
                d => d.length,
                mapFrom(
                    s =>
                        s.unitOfMeasure &&
                        s.length?.[
                            s.unitOfMeasure.toLowerCase() as keyof ItemMeasurement
                        ]
                )
            ),
            forMember(
                d => d.width,
                mapFrom(
                    s =>
                        s.unitOfMeasure &&
                        s.width?.[
                            s.unitOfMeasure.toLowerCase() as keyof ItemMeasurement
                        ]
                )
            ),
            forMember(
                d => d.height,
                mapFrom(
                    s =>
                        s.unitOfMeasure &&
                        s.height?.[
                            s.unitOfMeasure.toLowerCase() as keyof ItemMeasurement
                        ]
                )
            ),
            forMember(
                d => d.volume,
                mapFrom(
                    s =>
                        s.unitOfMeasure &&
                        s.volume?.[
                            s.unitOfMeasure.toLowerCase() as keyof ItemMeasurement
                        ]
                )
            )
        );
    },
};
